import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/login-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7ea5e74a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  class: "section1",
  style: {}
}
const _hoisted_3 = {
  class: "section",
  style: {}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Aboitiz logo",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "PAYMENT STATUS PORTAL", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Forgot Password", -1))
const _hoisted_7 = { style: {"text-align":"left"} }
const _hoisted_8 = {
  key: 0,
  style: {"color":"#27ae60"}
}
const _hoisted_9 = {
  key: 1,
  style: {"color":"#e74c3c"}
}
const _hoisted_10 = {
  key: 2,
  style: {"color":"#e74c3c"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Send reset password email ")
const _hoisted_12 = { style: {"text-align":"center","margin-top":"10px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Back to login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_a_form, {
                id: "components-form-demo-normal-login",
                model: _ctx.userState,
                labelCol: { span: 30 },
                wrapperCol: { span: 25 },
                style: {"padding":"0 40px","margin-top":"40px"},
                onFinish: _ctx.handleFinish
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.isSuccess)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_8, "Reset password email sent! Kindly check your email address."))
                      : _createCommentVNode("", true),
                    (_ctx.isInvalidEmail)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_9, "Invalid email address"))
                      : _createCommentVNode("", true),
                    (_ctx.hasError)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_10, "There was an error with your request. Please try again later."))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_a_form_item, { style: {"margin-bottom":"10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "email",
                        placeholder: "Email",
                        value: _ctx.userState.email,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userState.email) = $event)),
                        required: "",
                        class: "login-fields",
                        id: "email"
                      }, {
                        prefix: _withCtx(() => [
                          _createVNode(_component_UserOutlined, { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: "24" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                class: "login-btn",
                                "html-type": "submit",
                                type: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: "24" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_router_link, { to: "/login" }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish"])
            ])
          ]),
          _: 1
        }, 8, ["spinning"])
      ])
    ])
  ]))
}